define([
	"mobx",
	"csi/api",
	"csi/config/preferences",
	"csi/reflection",
	"csi/state/rootStore"
], function ({ reaction }, api, configPreferences, reflection, { localStore, routerStore }) {

	api.setRelationshipAccess("MerchVersion", "Secondaries", true);

	/**
	 * Track last MerchSeason URL visited
	 */
	reaction(
		() => routerStore.locationUrl,
		() => {
			const { locationNode, locationType, locationUrl } = routerStore;
			const rc = reflection.getNodeClass(locationNode);
			let seasonUrl;

			if (locationType === "MerchSeason") {
				seasonUrl = locationUrl;
			} else if (rc && rc.isDerivedFrom("MerchVersion")) {
				seasonUrl = locationNode.Season;
			}

			if (seasonUrl) {
				localStore.merch.seasonUrl = seasonUrl;
			}
		}
	);

	return {
		onAccessActionVersionRequired: function (/*Context*/ctx, /*Action*/action) {
			var season = ctx.getNode();
			return ctx.cache.getNode(season.__Parent__).Versions.length > 1;
		},

		postActionModifyFolderSecondaries: function (/*Controller*/ac) {
			let v = ac.widget.getSiblingView("TargetFolders");

			if (!v) {
				v = ac.widget.getSiblingView("TargetCollections");
			}

			if (v) {
				v.refreshWidget();
			}
		},

		postActionModifySecondaries: function (/*Controller*/ac) {
			const v = ac.widget.getSiblingView("Target");
			if (v) {
				v.refreshWidget();
				const plugin = v.getPlugin("MerchSecondarySelect");
				if (plugin) {
					plugin.refreshStore();
				}
			}
		}
	};
});